<template>
	<div class="form-loading"><BaseCmsLabel code="bankart_hold_loader" tag="span" /></div>
	<div v-if="leanpayData">
		<form :action="leanpayData.redirect_url" method="post" name="payment_confirm">
			<span v-html="leanpayData.hidden_form"></span>
			<input id="paymentHiddenButton" class="hidden-form-input" name="" type="submit" :value="labels.get('pay_by_credit_card')" />
		</form>
	</div>
</template>

<script setup>
	const { leanpayData } = useCheckout();
	const labels = useLabels();

	onMounted(() => {
		setTimeout(function(){
			if(leanpayData.value) {
				const paymentButton = document.getElementById('paymentHiddenButton');
				if (paymentButton) {
					paymentButton.click();
				}
			}
		}, 1000)
	})
</script>

<style lang="less" scoped>
	.hidden-form-input{display: block; width: 0; height: 0; background: @white; font-size: 0; line-height: 0; opacity: 0;}
	.form-loading{
		display: block!important;
		span{width: 400px; margin-left: -200px; font-size: 16px;}

		@media (max-width: @m){
			span{width: 300px; margin-left: -150px; font-size: 14px;}
		}
	}
</style>
